import React from 'react'
import {UserService} from '../../../services'
import {ChangeGSXTokenForm} from './ChangeGSXTokenForm'
import {useDispatch, useSelector} from 'react-redux'
import {showErrorToast, showSuccessToast} from '../../../state/toasts'

export const ChangeGSXTokenPage = () => {
    const dispatch = useDispatch()
    const {user} = useSelector((state) => state.auth)
    const handleGSXTokenUpdate = (values) => {
        const {gsx_token} = values

        new UserService(user.url)
            .refreshGSXToken(gsx_token)
            .then((response) => {
                if (!response) {
                    dispatch(showErrorToast('Error', 'Could not change gsx token.'))
                } else {
                    dispatch(
                        showSuccessToast(
                            'Success',
                            'Your GSX has been updated successfully'
                        )
                    )
                }
            })
            .catch((errors) => {
                dispatch(showErrorToast('Error', errors.response.data))
            })
    }

    return (
        <div className=" mx-auto col-sm-12 col-md-4">

            <ChangeGSXTokenForm onSubmit={handleGSXTokenUpdate}/>

        </div>
    )
}
